/** @format */

export const rateActionType = {
  setRate: "SET_RATE_APPLICATION",
};
